export enum OtpFlowEnum {
  BUSINESS_ONBOARDING = 'businessOnboarding',
  ONBOARDING_V2 = 'onboardingV2',
  UPDATE_USER_PROFILE = 'updateUserProfile',
  ONBOARDING = 'onboarding',
  PROFILE = 'profile',
  KYC = 'kyc',
}
